// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"ce_a bhj_h bhj_kf bhj_wb bhj_ss bhj_vr bhj_su bhj_sl"};